import React from 'react';

import ProfilingTagsFilter from '../ProfilingTagsFilter/ProfilingTagsFilter';
import UserPropertiesFilter from '../UserPropertiesFilter/UserPropertiesFilter';
import CommunityTagsFilter from '../CommunityTagsFilter/CommunityTagsFilter';
import FiltersRelation from '../FiltersRelation/FiltersRelation';

import {
  COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES,
  COMMUNITY_DASHBOARD_FILTER_TYPE
} from '../../../../../../helpers/constants';

import styles from './SingleFilter.module.css';

export default ({
  singleFilterIndex,
  appliedFilters,
  setAppliedFilters,
  filterRelation,
  setFilterRelation,
  userPropertiesMapping,
  showQuotaField,
  isFeasibilityChecker
}) => {
  const singleFilter = appliedFilters[singleFilterIndex];

  const onTypeChange = value => {
    const aFilters = appliedFilters;
    const preparedAppliedFilter = {};

    preparedAppliedFilter.type = value;

    if (value === COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG) {
      preparedAppliedFilter.tags = {};
    }

    if (value === COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY) {
      preparedAppliedFilter.userProperties = {};
    }

    if (value === COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY) {
      preparedAppliedFilter.community = {};
    }

    aFilters[singleFilterIndex] = preparedAppliedFilter;
    setAppliedFilters([...aFilters]);
  };

  const onFilterSelectCompleted = (
    property,
    value,
    subPath,
    isMultipleSelect
  ) => {
    const aFilters = appliedFilters;
    const preparedAppliedFilter = { ...singleFilter };

    if (
      preparedAppliedFilter &&
      preparedAppliedFilter.type ===
        COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY &&
      property === 'propertyName'
    ) {
      preparedAppliedFilter[subPath].propertyValue = null;
    }

    if (!isMultipleSelect) {
      if (value) {
        preparedAppliedFilter[subPath][property] = value;
      } else {
        preparedAppliedFilter[subPath][property] = null;
      }
    }
    if (isMultipleSelect) {
      const isExistingValue =
        preparedAppliedFilter &&
        preparedAppliedFilter[subPath] &&
        preparedAppliedFilter[subPath][property] &&
        Array.isArray(preparedAppliedFilter[subPath][property]) &&
        preparedAppliedFilter[subPath][property].indexOf(value) > -1;

      if (!isExistingValue) {
        if (
          !preparedAppliedFilter[subPath][property] ||
          !Array.isArray(preparedAppliedFilter[subPath][property])
        ) {
          preparedAppliedFilter[subPath][property] = [value];
        } else {
          preparedAppliedFilter[subPath][property] = [
            ...preparedAppliedFilter[subPath][property],
            value
          ];
        }
      } else {
        const removedArrayValue = preparedAppliedFilter[subPath][
          property
        ].filter(v => v !== value);
        preparedAppliedFilter[subPath][property] = removedArrayValue;
      }
    }

    aFilters[singleFilterIndex] = preparedAppliedFilter;
    setAppliedFilters([...aFilters]);
  };

  const onSelectAllClick = async (
    property,
    values,
    subPath,
    allValuesSelected,
    searchProfilingTagValues
  ) => {
    const aFilters = appliedFilters;
    const preparedAppliedFilter = { ...singleFilter };

    if (allValuesSelected) {
      preparedAppliedFilter[subPath][property] = [];
    } else if (values && values.length < 10) {
        const selectedValues = values.map(v => v.value);
        preparedAppliedFilter[subPath][property] = selectedValues;
      } else {
        const fetchedOptions = await searchProfilingTagValues(3, '');
        const newFetchedOptions =
          fetchedOptions && fetchedOptions.length
            ? fetchedOptions.map(v => v.value)
            : [];
        preparedAppliedFilter[subPath][property] = newFetchedOptions;
      }

    aFilters[singleFilterIndex] = preparedAppliedFilter;
    setAppliedFilters([...aFilters]);
  };

  const getTypeOptions = () => [
    {
      label:
        COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES[
          COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG
        ],
      value: COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG
    },
    {
      label:
        COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES[
          COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY
        ],
      value: COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY
    },
    {
      label:
        COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES[
          COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY
        ],
      value: COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY
    }
  ];

  let singleFilterComponents = null;

  if (singleFilter.type === COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG) {
    singleFilterComponents = (
      <ProfilingTagsFilter
        singleFilterIndex={singleFilterIndex}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        onTypeChange={onTypeChange}
        onFilterSelectCompleted={onFilterSelectCompleted}
        getTypeOptions={getTypeOptions}
        showQuotaField={showQuotaField}
        onSelectAllClick={onSelectAllClick}
      />
    );
  }

  if (singleFilter.type === COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY) {
    singleFilterComponents = (
      <UserPropertiesFilter
        singleFilterIndex={singleFilterIndex}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        onTypeChange={onTypeChange}
        onFilterSelectCompleted={onFilterSelectCompleted}
        getTypeOptions={getTypeOptions}
        userPropertiesMapping={userPropertiesMapping}
        showQuotaField={showQuotaField}
        isFeasibilityChecker={isFeasibilityChecker}
        onSelectAllClick={onSelectAllClick}
      />
    );
  }

  if (singleFilter.type === COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY) {
    singleFilterComponents = (
      <CommunityTagsFilter
        singleFilterIndex={singleFilterIndex}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        onTypeChange={onTypeChange}
        onFilterSelectCompleted={onFilterSelectCompleted}
        getTypeOptions={getTypeOptions}
        onSelectAllClick={onSelectAllClick}
      />
    );
  }

  return (
    <div className={styles.singleFilter}>
      {singleFilterComponents}
      {singleFilterIndex < appliedFilters.length - 1 ? (
        <FiltersRelation
          filterRelation={filterRelation}
          setFilterRelation={setFilterRelation}
        />
      ) : null}
    </div>
  );
};
